import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";

///Styles
import { toast } from "react-toastify";
import { FaFilter } from 'react-icons/fa'
import { ContainerLoading, Container, Content, Table, Button, Bar, BarContainer, ValueContainer } from './styles';

///Componentes
import { SpaceLoader } from "../../../loaders/spaceLoader";
import { FormatMoney } from "../formatMoney";
import { ContainerThatCloseOutside } from "../../../ContainerThatCloseOutside";
import { ButtonExportExcel } from "../buttonExportExcel";


///Services
import { api } from "../../../../services/api";
import { useAdministrativeContext } from "../../../../pages/administrativePanel/administrativePanelContext";
import { download_csv } from "../centralizedModal/JsonToCsv";
import moment from "moment";


export function CurveAbc() {
    const ref = useRef(null)
    const {
        startDate,
        endDate,
        listBusinessToFilter,
        listSalesChannelsId
    } = useAdministrativeContext();

    const [companies, setCompanies] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [loadingButton, setLoadingButton] = useState(false);
    const [openButton, setOpenButton] = useState(false);
    const [open, setOpen] = useState(false);
    const [quantDays, setQuantDays] = useState('');

    const handleNewRankings = useCallback(async () => {
        setLoadingButton(true);
        const response = await api.post(`/getResumeRanking/?page=${page}`, {
            rankingDatas: {
                business: listBusinessToFilter,
                salesChannels: listSalesChannelsId,
                endDate: endDate,
                startDate: startDate,
                page: page
            },
            quantDays
        },
            {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })
        const { businesses, next_page } = response.data;

        setCompanies([...companies, ...businesses]);
        setPage(next_page);
        setLoadingButton(false);
    }, [companies, endDate, listBusinessToFilter, listSalesChannelsId, page, startDate, quantDays])

    useEffect(() => {
        async function loadRankings() {
            setLoading(true)
            const response = await api.post('/getResumeRanking/?page=1', {
                rankingDatas: {
                    business: listBusinessToFilter,
                    salesChannels: listSalesChannelsId,
                    endDate: endDate,
                    startDate: startDate,
                }
            },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                })
            const { businesses, next_page } = response.data
            setCompanies(businesses);
            setPage(next_page);
            setLoading(false)
        }
        loadRankings();
    }, [endDate, listBusinessToFilter, listSalesChannelsId, startDate]);

    const total = useMemo(() => companies.length, [companies]);

    const filterRankings = useCallback(async (event) => {
        event.preventDefault()
        setLoading(true)

        try {
            const response = await api.post('/getResumeRanking/?page=0',
                {
                    rankingDatas: {
                        business: listBusinessToFilter,
                        salesChannels: listSalesChannelsId,
                        endDate: endDate,
                        startDate: startDate,
                    },
                    quantDays
                }
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                })
            const { businesses, next_page } = response.data

            if (businesses === undefined)
                throw new Error()

            setCompanies(businesses)
            setPage(next_page)

        } catch (error) {
            //console.log(error)
            toast.error('Algo deu errado')
        }
        setOpen(false)
        setLoading(false)
    }, [endDate, listBusinessToFilter, listSalesChannelsId, quantDays, startDate]);

    async function handleDownloadCSV() {
        setLoading(true);
        const titleCSV = `Ranking_${moment(startDate).format('DD-MM-YYYY-HH:mm')}ate${moment(endDate).format('DD-MM-YYYY-HH:mm')}`

        const response =
            await api.get(`/getExportRankingToExcel/?business=${listBusinessToFilter}&startDate=${startDate}&endDate=${endDate}&salesChannels=${listSalesChannelsId}&quantDays=${quantDays}`)
        setLoading(false);

        const { success, datas } = response.data

        if (!success) {
            toast.error('Algo deu errado, faça o login novamente')
            return
        }

        download_csv(datas, titleCSV)
    }

    if (loading) {
        return (
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return (
        <Container>
            <ButtonExportExcel
                    open={openButton}
                    setOpen={setOpenButton}
                    handleDownloadCSV={handleDownloadCSV}
            />
            <Content>
                <div className='filterContainer'>
                    <FaFilter
                        onClick={() => setOpen(!open)}
                    />

                    {
                        open &&
                        <ContainerThatCloseOutside
                            handleClickOutside={() => setOpen(false)}
                            availableToClick={open}
                            ref={ref}
                        >
                            <form className='filter' onSubmit={filterRankings}>
                                <span>Inaugurado a mais de: </span>
                                <input
                                    type={'number'}
                                    placeholder='Digite a quantidade de dias'
                                    value={quantDays}
                                    onChange={(event) => setQuantDays(event.target.value)}
                                />
                                <button type='submit'>Filtrar</button>
                            </form>
                        </ContainerThatCloseOutside>
                    }
                </div>

                <Table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Empresa</th>
                            <th>Id Custimizado</th>
                            <th>Valor</th>
                            <th>Percentual</th>
                            <th>Percentual Acumulado</th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            companies?.map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td className={item.classificacao}>{item.classificacao}</td>
                                        <td>{item.name}</td>
                                        <td>{item.idCustomized}</td>
                                        <td>
                                            <FormatMoney value={item.value} />
                                        </td>
                                        <td>
                                            {
                                                <BarContainer>
                                                    <Bar percent={item.perc}>
                                                        {
                                                            (item.perc) >= 70 ?
                                                                item.perc+'%'
                                                                :
                                                                <></>
                                                        }
                                                    </Bar>

                                                    {
                                                        (item.perc) < 70 ?
                                                            item.perc+'%'
                                                            :
                                                            <></>
                                                    }
                                                </BarContainer>
                                            }

                                            <ValueContainer>
                                               {item.perc+'%'}
                                            </ValueContainer>
                                        </td>
                                        <td>{item.percAcumulado}%</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>

                    <tfoot>
                        <tr>
                        <td colSpan={2}>Listadas: {total} Empresas</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        </tr>
                    </tfoot>
                </Table>
            </Content>

            {
                page !== null &&
                <Button onClick={handleNewRankings}>
                    {
                        loadingButton ?
                            '...aguarde'
                            :
                            'Ver mais'
                    }
                </Button>
            }
        </Container>
    )
}